import { render, staticRenderFns } from "./WizardItem.vue?vue&type=template&id=a19f1c4e"
import script from "./WizardItem.vue?vue&type=script&lang=ts"
export * from "./WizardItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports